import { render, staticRenderFns } from "./ConvenioMedico.vue?vue&type=template&id=7477edd6&"
import script from "./ConvenioMedico.vue?vue&type=script&lang=js&"
export * from "./ConvenioMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports